import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/reprise.css';
import './lib/posthog.js';
import App from './App.jsx';
import EnvoiLibre from './screens/EnvoiLibre.jsx';

// /envoi/<code> : page autonome (partenaires, sans compte ni parcours de reprise).
const envoi = window.location.pathname.match(/^\/envoi\/([a-z0-9]{10})\/?$/);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {envoi ? <EnvoiLibre code={envoi[1]} /> : <App />}
  </React.StrictMode>,
);
